import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { IntegrationStatusNum } from '@/pages/store-management/master-stores/service';
import { StoreManagementDeliveryStoreActivationJobsService } from '@/services/StoreManagement/DeliveryStoreActivationJobs/StoreManagementDeliveryStoreActivationJobsService';

export type StoreManagementDeliveryStoreActivationJobLatestParams = {
  delivery_store_id: string;
};

export type StoreManagementDeliveryStoreActivationJobLatestResponse = {
  id: string;
  delivery_store_id: string;
  integration_date: string;
  status: IntegrationStatusNum;
  created_at: string;
};

export const useStoreManagementDeliveryStoreActivationJobLatest = async (
  params: StoreManagementDeliveryStoreActivationJobLatestParams
): Promise<StoreManagementDeliveryStoreActivationJobLatestResponse | null> => {
  const storeManagementDeliveryStoreActivationJobsService =
    new StoreManagementDeliveryStoreActivationJobsService(getClient());
  try {
    return await storeManagementDeliveryStoreActivationJobsService.latest(
      params
    );
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
